// TokenHighlighter draws colored boxes around search terms in
// the a text field. Well, that's what it appears to do at least. :)
//
// HTML text fields don't allow you to style individual bits of text.
// Here'a brief rundown of how we achieve this affect. Warning: you'll
// probably need a shower after you read this.
//
// 1. We have a div positioned behind the text input. It has exactly the same dimensions and
//    font size as the text input. The text input has a transparent bg.
// 2. When the user types into the text field, we copy it into the "background" div,
//    wrapping each token in a span, with a class that indicates whether it's
//    valid, invalid or whitespace. These spans are not visible to the user.
// 3. We loop over the spans we just created and use them to calculate the pixel coordinates
//    of each token in the text input. We create divs centerd on each token, styled to be the
//    right color.
//
// While it is possible to get highlighting without step 3, by simply giving the spans
// a background color, it's *not* possible to add padding. This looks kind of weird, so we do
// the extra step

export default class TokenHighlighter {
  constructor($input, $background, tokenRuler, query) {
    this.resize = this.resize.bind(this);
    this.updateBackgroundSize = this.updateBackgroundSize.bind(this);
    this.delayedScroll = this.delayedScroll.bind(this);
    this.startDrag = this.startDrag.bind(this);
    this.endDrag = this.endDrag.bind(this);
    this.scroll = this.scroll.bind(this);
    this.render = this.render.bind(this);
    this.$input = $input;
    this.$background = $background;
    this.tokenRuler = tokenRuler;
    this.query = query;
    this.$highlights = this.$background.find(".highlights");
    this.updateBackgroundSize();

    // Fixes FOUT (flash of unstyled text) issue with webfonts by rendering the
    // highlights after the fonts are loaded. This must only be done once. See
    // #4550, #4588.
    document.fonts.ready.then(this.render);
  }

  bind() {
    this.query.on("change", this.render);
    this.$input.on("keyup keydown focus change scroll select", this.scroll);
    this.$input.on("blur touchend", this.delayedScroll);
    $(window).on("resize", this.resize);
    this.$input.on("mousedown", this.startDrag);
    $(window).on("mouseup", this.endDrag); // The mouseup event may occur when pointer is outside of the input
  }

  unbind() {
    this.query.off("change", this.render);
    this.$input.off("keyup keydown focus change scroll select", this.scroll);
    this.$input.off("blur touchend", this.delayedScroll);
    $(window).off("resize", this.resize);
    this.$input.off("mousedown", this.startDrag);
    $(window).off("mouseup", this.endDrag);
  }

  resize() {
    this.updateBackgroundSize();
    this.scroll();
  }

  updateBackgroundSize() {
    this.$background.height(this.$input.height());
    this.$background.width(this.$input.width());
  }

  // TODO:We need to test this on different linux setups to see if this fix works for all of them.
  // Also, perhaps this will get fixed in chrome and then our fix will be SOL.
  //
  // There is a bug on Chrome & Chromium / Linux when using a HighDPI display.
  // input.scrollLeft returns a size that has been "de-scaled" twice.
  // i.e physical_pixels / (devicePixelRatio * devicePixelRatio). To get the correct
  // value, we simply multiply by devicePixelRatio to "undo" one of the scalings.
  //
  // The bug only seems to be present for inputs, not for divs and other non-OS widgets.
  //
  normalizedScroll(scroll) {
    if (!scroll || scroll === 0) {
      return 0;
    }
    const agent = window.navigator.userAgent;
    const isChromeOnLinux = !!(
      agent.match("X11; Linux") &&
      (agent.match("Chrome") || agent.match("Chromium"))
    );
    if (isChromeOnLinux) {
      return scroll * (window.devicePixelRatio || 1);
    }
    return scroll;
  }

  // Some events (like blur) update the scroll *after* the event handler
  // is fired. So we use a timeout to make our code run after that.
  delayedScroll() {
    clearTimeout(this.delayedScrollTimeout);
    this.delayedScrollTimeout = setTimeout(() => {
      this.render();
      return this.scroll();
    }, 100);
  }

  startDrag() {
    this.dragging = true;
    clearTimeout(this.draggingTimeout);
    this.draggingTimeout = setTimeout(() => this.$background.hide(), 500);
  }

  endDrag() {
    if (this.dragging) {
      this.dragging = false;
      clearTimeout(this.draggingTimeout);
      this.$background.show();
      this.scroll();
    }
  }

  scroll() {
    this.$background.scrollLeft(
      this.normalizedScroll(this.$input.scrollLeft()),
    );
  }

  render() {
    this.tokenRuler.update(this.query.tokens, this.query.selectedToken);
    this.clear();
    this.renderHighlights();
  }

  clear() {
    this.$highlights.empty();
  }

  renderHighlights() {
    const spans = this.tokenRuler.spans;
    for (let i = 0, end = spans.length; i < end; i += 1) {
      if (this.tokenRuler.isHighlightable(i)) {
        const $highlight = $("<mark>");
        $highlight.addClass(spans[i].attr("class"));
        this.$highlights.append($highlight);
        const dimensions = this.tokenRuler.dimensions(
          i,
          this.$background.scrollLeft(),
        );
        dimensions.height += 3;
        dimensions.top -= 2;

        $highlight.css(dimensions);
      }
    }
  }
}
